var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drawer-container"},[_c('div',[_c('h3',{staticClass:"drawer-title"},[_vm._v("页面设置")]),_c('div',{staticClass:"drawer-item"},[_c('span',[_vm._v("选择主题色")]),_c('ThemePicker',{staticStyle:{"float":"right","height":"26px","margin":"-3px 8px 0 0","z-index":"9999"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }